const routes = [{
    path: '/combustibleGasManage/index', //布控管理
    name: 'combustibleGasManage',
    component: () => import('./view/index.vue'),
    // redirect: '/combustibleGasManage/index',
    meta: {
        requireAuth: true
    },

}]
export default routes